import { render, staticRenderFns } from "./info-moblie-width.vue?vue&type=template&id=56b52588&"
import script from "./info-moblie-width.vue?vue&type=script&lang=js&"
export * from "./info-moblie-width.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports